import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { NavigationProvider } from '@/contexts/NavigationContext';
import { ModalProvider } from '@/contexts/ModalContext';
import { FeatureFlagProvider } from '@/contexts/FeatureFlagContext';
import { TutorialsProvider } from '@/contexts/TutorialsContext';

/**
 * Implements theme management, navigation tracking, feature flags, guided
 * tutorials, and provides the root layout for all pages.
 */
const App: React.FC = () => {
    return (
        <FeatureFlagProvider>
            <ThemeProvider>
                <NavigationProvider>
                    <ModalProvider>
                        <TutorialsProvider>
                            <Outlet />
                        </TutorialsProvider>
                    </ModalProvider>
                </NavigationProvider>
            </ThemeProvider>
        </FeatureFlagProvider>
    );
};

export default App;